import React from 'react';
import {Container, Card, Row, Col} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/styles/C911Ced.scss';
import { useSelector } from 'react-redux';
import {CabezaCedula,IdentEsc,VersionCifras,PieCedulaMedia,ClaveEsc,CicloCenso,TotalAlumnos,SeparaMiles,Separador,SumaSet,NotaAula,ActHojas} from './ToolsCed';

// control de documentos
//let hojaact=0;
let tothoja=0;
function NotaSeccionI(alumxgdo){
  if(alumxgdo===0){
    return(
      <div>
        <Row className="no-gutters margensupnotatabla">
          <Col xs={12} className="bordetransparente text-left fontmaspeque"><p><b>*</b>&nbsp;&nbsp;&nbsp;Escuela cuyo programa educativo o capacitación no se imparte por grado.</p></Col>
        </Row>
        <Row className="no-gutters pocomargensupnotatabla">
          <Col xs={12} className="bordetransparente text-left fontmaspeque"><p><b>**</b>&nbsp;Se refiere al número de docentes por nivel que imparte, el cual puede diferir del personal de la sección II, donde se contabiliza de manera única al docente de la institución.</p></Col>
        </Row>
      </div>
    )
  }else{
    return (
      <div>
        <Row className="margeninfmedio"><Col xs={12}></Col></Row>
        <Row className="no-gutters margensupnotatabla">
          <Col xs={12} className="bordetransparente text-left fontmaspeque"><p><b>*</b>&nbsp;Se refiere al número de docentes por nivel que imparte, el cual puede diferir del personal de la sección II, donde se contabiliza de manera única al docente de la institución.</p></Col>
        </Row>
      </div>
    )
  }
}

function AreaInst(props){
  if((props.cifras.cvect).substring(2,5)==='MSU'){
    return(
    <div>
    <Row className="no-gutters margeninf">
    <Col xs={10} className="font-weight-bold"><div className="bordetransparente"><p>Pers. Áreas centrales</p></div></Col>
    <Col xs={2} className="font-weight-bold"><div className="borde text-center"><p>{props.cifras.perstotarea}</p></div></Col>
    </Row>
    <Row className="no-gutters margeninf">
    <Col xs={10} className="font-weight-bold"><div className="bordetransparente"><p>Otros</p></div></Col>
    <Col xs={2} className="font-weight-bold"><div className="borde text-center"><p>{props.cifras.persotro}</p></div></Col>
    </Row>
    </div>
    )
  }else {return(
    <Row className="no-gutters margeninf">
    <Col xs={10} className="font-weight-bold"><div className="bordetransparente"><p>Otros</p></div></Col>
    <Col xs={2} className="font-weight-bold"><div className="borde text-center"><p>{props.cifras.persotro}</p></div></Col>
    </Row>
  )}
};

function TotalPersonal(props){
  if((props.cifras.cvect).substring(2,5)==='MSU'){
    return(
    <Col xs={4}>
      <Row>
        <Col xs={12}>
          <Row className="no-gutters margeninf">
            <Col xs={10} className="font-weight-bold"><div className="bordetransparente"><p>Total de Personal</p></div></Col>
            <Col xs={2} className="font-weight-bold"><div className="borde text-center"><p>{props.cifras.perstotinst}</p></div></Col>
          </Row>
          <Row className="no-gutters margeninf">
            <Col xs={1} className="bordetransparente"></Col>
            <Col xs={9}><div className="bordetransparente"><p>Áreas centrales</p></div></Col>
            <Col xs={2}><div className="borde text-center"><p>{props.cifras.perstotarea}</p></div></Col>
          </Row>
          <Row className="no-gutters margeninf">
            <Col xs={1} className="bordetransparente"></Col>
            <Col xs={9}><div className="bordetransparente"><p>Facultades, escuelas, centros, divisiones o departamentos</p></div></Col>
            <Col xs={2}><div className="borde text-center"><p>{props.cifras.perstotesc}</p></div></Col>
          </Row>
        </Col>
      </Row>
    </Col>)
  } else {
      return(
        <Col xs={4}>
          <Row>
            <Col xs={12}>
              <Row className="no-gutters margeninf">
                <Col xs={10} className="font-weight-bold"><div className="bordetransparente"><p>Total de Personal</p></div></Col>
                <Col xs={2} className="font-weight-bold"><div className="borde text-center"><p>{props.cifras.perstotesc}</p></div></Col>
              </Row>
            </Col>
          </Row>
        </Col>
        )
      }
}

function DatosCifrasSup(props){
  let hojent=0;
  let hojfracc=0;
  let numhoja=0;
  let reg1hoja=0;
  let poselem=props.indice+1;
  let alumxgdo=SumaSet([props.cifras.alum1,props.cifras.alum2,props.cifras.alum3,props.cifras.alum4,props.cifras.alum5,props.cifras.alum6]);

  if (poselem<=2){
    numhoja=1;
  }else{
    hojent=Math.trunc((poselem-2)/props.regxanexo);
    hojfracc=(poselem-2) % props.regxanexo;
    if (hojfracc>0){
      hojfracc=1;
    }
    numhoja=1+hojent+hojfracc;
  }
  if (numhoja<=1){
    reg1hoja=1;
  }else{
    reg1hoja=(numhoja-1)*props.regxanexo;
  }
  //hojaact=numhoja
  if (numhoja>tothoja){
    tothoja=numhoja;
  }

  return (
    <div>
      {Separador (poselem,reg1hoja)}
      <Row><Col xs={12}><h6 className="font-weight-bold">I. ALUMNOS (MATRÍCULA, NUEVO INGRESO, EGRESADOS Y TITULADOS), DOCENTES Y AULAS</h6></Col></Row>                        
      <Row>
        <Col xs={8}>
          <Row>
            <Col xs={12}>
              <Row className="no-gutters text-center margeninf">
                <Col xs={4}><div><p></p></div></Col>
                <Col xs={1}><div><p>1°</p></div></Col>
                <Col xs={1}><div><p>2°</p></div></Col>
                <Col xs={1}><div><p>3°</p></div></Col>
                <Col xs={1}><div><p>4°</p></div></Col>
                <Col xs={1}><div><p>5°</p></div></Col>
                <Col xs={1}><div><p>6°</p></div></Col>
                <Col xs={2}><div><p>Total</p></div></Col>            
              </Row>
              <Row className="no-gutters text-center margeninf">
                <Col xs={4}><div className="bordetransparente text-left"><p>Matrícula{alumxgdo===0?' *':''}</p></div></Col>
                <Col xs={1}><div className="borde"><p>{props.cifras.alum1}</p></div></Col>
                <Col xs={1}><div className="borde"><p>{props.cifras.alum2}</p></div></Col>
                <Col xs={1}><div className="borde"><p>{props.cifras.alum3}</p></div></Col>
                <Col xs={1}><div className="borde"><p>{props.cifras.alum4}</p></div></Col>
                <Col xs={1}><div className="borde"><p>{props.cifras.alum5}</p></div></Col>
                <Col xs={1}><div className="borde"><p>{props.cifras.alum6}</p></div></Col>
                <Col xs={2}><div className="borde"><p>{SeparaMiles(props.cifras.alumtot)}</p></div></Col>
              </Row>
              <Row className="no-gutters text-center margeninf">
                <Col xs={4}><div className="bordetransparente text-left"><p>Docentes frente a grupo {alumxgdo===0?'**':'*'}</p></div></Col>
                <Col xs={1}><div className="borde"><p>-</p></div></Col>
                <Col xs={1}><div className="borde"><p>-</p></div></Col>
                <Col xs={1}><div className="borde"><p>-</p></div></Col>
                <Col xs={1}><div className="borde"><p>-</p></div></Col>
                <Col xs={1}><div className="borde"><p>-</p></div></Col>
                <Col xs={1}><div className="borde"><p>-</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.docniv}</p></div></Col>            
              </Row>
              <Row className="no-gutters text-center margeninf">
                <Col xs={4}><div className="bordetransparente text-left"><p>Nuevo ingreso</p></div></Col>
                <Col xs={1}><div className="borde"><p>{props.cifras.alumtotnvoing}</p></div></Col>
                <Col xs={1}><div className="borde"><p>-</p></div></Col>
                <Col xs={1}><div className="borde"><p>-</p></div></Col>
                <Col xs={1}><div className="borde"><p>-</p></div></Col>
                <Col xs={1}><div className="borde"><p>-</p></div></Col>
                <Col xs={1}><div className="borde"><p>-</p></div></Col>
                <Col xs={2}><div className="borde"><p>{SeparaMiles(props.cifras.alumtotnvoing)}</p></div></Col>            
              </Row>              
              <Row className="no-gutters text-center margeninf">
                <Col xs={4}><div className="bordetransparente text-left"><p>Egresados</p></div></Col>
                <Col xs={1}><div className="borde"><p>-</p></div></Col>
                <Col xs={1}><div className="borde"><p>-</p></div></Col>
                <Col xs={1}><div className="borde"><p>-</p></div></Col>
                <Col xs={1}><div className="borde"><p>-</p></div></Col>
                <Col xs={1}><div className="borde"><p>-</p></div></Col>
                <Col xs={1}><div className="borde"><p>-</p></div></Col>
                <Col xs={2}><div className="borde"><p>{SeparaMiles(props.cifras.alumtotegreso)}</p></div></Col>            
              </Row>
              <Row className="no-gutters text-center margeninf">
                <Col xs={4}><div className="bordetransparente text-left"><p>Titulados</p></div></Col>
                <Col xs={1}><div className="borde"><p>-</p></div></Col>
                <Col xs={1}><div className="borde"><p>-</p></div></Col>
                <Col xs={1}><div className="borde"><p>-</p></div></Col>
                <Col xs={1}><div className="borde"><p>-</p></div></Col>
                <Col xs={1}><div className="borde"><p>-</p></div></Col>
                <Col xs={1}><div className="borde"><p>-</p></div></Col>
                <Col xs={2}><div className="borde"><p>{SeparaMiles(props.cifras.alumtottitulo)}</p></div></Col>            
              </Row>
            </Col>
          </Row>
        </Col>
        <Col xs={2}>
          <Row className="text-center">
            <Col xs={12}>
              <Row className="no-gutters margeninf">
                <Col xs={6}><div><p>Hom</p></div></Col>
                <Col xs={6}><div><p>Muj</p></div></Col>
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={6}><div className="borde"><p>{SeparaMiles(props.cifras.alumhom)}</p></div></Col>
                <Col xs={6}><div className="borde"><p>{SeparaMiles(props.cifras.alummuj)}</p></div></Col>          
              </Row>
            </Col>
          </Row>
        </Col>
        <Col xs={2}>
          <Row>
            <Col xs={12}>
              <Row className="no-gutters text-center margeninf">
                <Col xs={8}><div><p>&nbsp;</p></div></Col>
                <Col xs={4}><div><p>Aulas</p></div></Col>
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={8}><div className="bordetransparente"><p>Existentes</p></div></Col>
                <Col xs={4} className="text-center"><div className="borde"><p>{props.cifras.aulaexis}</p></div></Col>          
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={8}><div className="bordetransparente"><p>En Uso</p></div></Col>
                <Col xs={4} className="text-center"><div className="borde"><p>{props.cifras.aulauso}</p></div></Col>         
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={8}><div className="bordetransparente"><p>Adaptadas</p></div></Col>
                <Col xs={4} className="text-center"><div className="borde"><p>{props.cifras.aulaadap}</p></div></Col>           
              </Row>
              <Row className="margensupaula">
                <Col xs={12} className="text-left">
                  <p className="fontmaspeque">{NotaAula()}</p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      {NotaSeccionI(alumxgdo)}
      <Row className="margeninf">
        <Col xs={10}></Col>
        <Col xs={2} className="text-left">
          <p className="fontmaspeque">&nbsp;</p>
        </Col>
      </Row>
      <Row><Col xs={12}><h6 className="font-weight-bold">II. PERSONAL POR FUNCIÓN</h6></Col></Row>
      <Row>
        <Col xs={4}>
          <Row>
            <Col xs={12}>
              <Row className="no-gutters margeninf">
                <Col xs={10} className="font-weight-bold"><div><p>Personal Directivo</p></div></Col>
                <Col xs={2} className="font-weight-bold">
                  <div className="borde text-center"><p>{props.cifras.dir}</p></div>
                </Col>            
              </Row>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Row className="no-gutters margeninf">
                <Col xs={10} className="font-weight-bold"><div><p>Personal Docente</p></div></Col>
                <Col xs={2} className="font-weight-bold">
                  <div className="borde text-center"><p>
                      {SumaSet([props.cifras.doc,props.cifras.docinv])}
                  </p></div>
                </Col>            
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={1} className="bordetransparente"></Col>
                <Col xs={9}><div className="bordetransparente"><p>Docente</p></div></Col>
                <Col xs={2}><div className="borde text-center"><p>{props.cifras.doc}</p></div></Col>            
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={1} className="bordetransparente"></Col>
                <Col xs={9}><div className="bordetransparente"><p>Investigador y Auxiliar</p></div></Col>
                <Col xs={2}><div className="borde text-center"><p>{props.cifras.docinv}</p></div></Col>            
              </Row>
            </Col>
          </Row>
        </Col>
        <Col xs={4}>
          <Row>
            <Col xs={12}>
              <Row className="no-gutters margeninf">
                <Col xs={10} className="font-weight-bold"><div className="bordetransparente"><p>Pers. Investigador</p></div></Col>
                <Col xs={2} className="font-weight-bold"><div className="borde text-center"><p>{props.cifras.investig}</p></div></Col>            
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={10} className="font-weight-bold"><div className="bordetransparente"><p>Pers. Aux. de Investigador</p></div></Col>
                <Col xs={2} className="font-weight-bold"><div className="borde text-center"><p>{props.cifras.auxinv}</p></div></Col>            
              </Row>
              <Row className="no-gutters margeninf">
                <Col xs={10} className="font-weight-bold"><div className="bordetransparente"><p>Pers. Administrativo</p></div></Col>
                <Col xs={2} className="font-weight-bold"><div className="borde text-center"><p>{props.cifras.admvo}</p></div></Col>            
              </Row>
              {AreaInst (props)}
            </Col>
          </Row>
        </Col>
        {TotalPersonal(props)}
      </Row>
    </div>
  );
} //DatosCifrasSup

function DatosCifrasSupNEE(props){
  let hojent=0;
  let hojfracc=0;
  let numhoja=0;
  let reg1hoja=0;
  let poselem=props.indice+1;

  if (poselem<=2){
    numhoja=1;
  }else{
    hojent=Math.trunc((poselem-2)/props.regxanexo);
    hojfracc=(poselem-2) % props.regxanexo;
    if (hojfracc>0){
      hojfracc=1;
    }
    numhoja=1+hojent+hojfracc;
  }
  if (numhoja<=1){
    reg1hoja=1;
  }else{
    reg1hoja=(numhoja-1)*props.regxanexo;
  }
  //hojaact=numhoja
  if (numhoja>tothoja){
    tothoja=numhoja;
  }
  return (
    <div>
      {Separador (poselem,reg1hoja)}
      <Row><Col xs={12}><h6 className="font-weight-bold">III. ALUMNOS CON DISCAPACIDAD Y NECESIDADES EDUCATIVAS ESPECIALES</h6></Col></Row>                        
      <Row>
        <Col xs={6}>
          <Row>
            <Col xs={12}>
              <Row className="no-gutters margeninf">
                <Col xs={6} className="font-weight-bold text-left"><div><p>Discapacidad</p></div></Col>                
                <Col xs={2} className="text-center"><div><p>Hombres</p></div></Col>
                <Col xs={2} className="text-center"><div><p>Mujeres</p></div></Col>
                <Col xs={2} className="font-weight-bold text-center"><div><p>Total</p></div></Col>            
              </Row>
              <Row className="no-gutters text-center margeninf">
                <Col xs={1} className="bordetransparente"></Col>
                <Col xs={5}><div className="bordetransparente text-left"><p>Física / motriz</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.dhomfisica}</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.dmujfisica}</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.dtotfisica}</p></div></Col>
              </Row>
              <Row className="no-gutters text-center margeninf">
                <Col xs={1} className="bordetransparente"></Col>                
                <Col xs={5}><div className="bordetransparente text-left"><p>Intelectual</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.dhomintelec}</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.dmujintelec}</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.dtotintelec}</p></div></Col>
              </Row>
              <Row className="no-gutters text-center margeninf">
                <Col xs={1} className="bordetransparente"></Col>
                <Col xs={5}><div className="bordetransparente text-left"><p>Múltiple</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.dhommulti}</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.dmujmulti}</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.dtotmulti}</p></div></Col>
              </Row>
              <Row className="no-gutters text-center margeninf">
                <Col xs={1} className="bordetransparente"></Col>
                <Col xs={5} className="bordetransparente text-left font-weight-bold"><p>Auditiva</p></Col>
                <Col xs={2} className="bordetransparente font-weight-bold"><p></p></Col>
                <Col xs={2} className="bordetransparente font-weight-bold"><p></p></Col>
                <Col xs={2} className="bordetransparente font-weight-bold"><p></p></Col>
              </Row>
              <Row className="no-gutters text-center margeninf">
                <Col xs={2} className="bordetransparente"></Col>
                <Col xs={4}><div className="bordetransparente text-left"><p>Hipoacusia</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.dhomhipoac}</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.dmujhipoac}</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.dtothipoac}</p></div></Col>
              </Row>
              <Row className="no-gutters text-center margeninf">
                <Col xs={2} className="bordetransparente"></Col>
                <Col xs={4}><div className="bordetransparente text-left"><p>Sordera</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.dhomsordera}</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.dmujsordera}</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.dtotsordera}</p></div></Col>
              </Row>
              <Row className="no-gutters text-center margeninf">
                <Col xs={1} className="bordetransparente"></Col>
                <Col xs={5} className="bordetransparente text-left font-weight-bold"><p>Visual</p></Col>
                <Col xs={2} className="bordetransparente font-weight-bold"><p></p></Col>
                <Col xs={2} className="bordetransparente font-weight-bold"><p></p></Col>
                <Col xs={2} className="bordetransparente font-weight-bold"><p></p></Col>
              </Row>
              <Row className="no-gutters text-center margeninf">
                <Col xs={2} className="bordetransparente"></Col>
                <Col xs={4}><div className="bordetransparente text-left"><p>Baja visión</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.dhombajavision}</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.dmujbajavision}</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.dtotbajavision}</p></div></Col>
              </Row>
              <Row className="no-gutters text-center margeninf">
                <Col xs={2} className="bordetransparente"></Col>
                <Col xs={4}><div className="bordetransparente text-left"><p>Ceguera</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.dhomceguera}</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.dmujceguera}</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.dtotceguera}</p></div></Col>
              </Row>
              <Row className="no-gutters text-center margeninf">
                <Col xs={1} className="bordetransparente"></Col>
                <Col xs={5}><div className="bordetransparente text-left"><p>Psicosocial</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.dhompsicosoc}</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.dmujpsicosoc}</p></div></Col>
                <Col xs={2}><div className="borde"><p>{props.cifras.dtotpsicosoc}</p></div></Col>
              </Row>
              <Row className="no-gutters text-center margeninf">
                <Col xs={1} className="bordetransparente"></Col>
                <Col xs={5} className="font-weight-bold"><div className="bordetransparente text-left"><p>Total</p></div></Col>
                <Col xs={2} className="borde font-weight-bold"><p>{props.cifras.dhomtot}</p></Col>
                <Col xs={2} className="borde font-weight-bold"><p>{props.cifras.dmujtot}</p></Col>
                <Col xs={2} className="borde font-weight-bold"><p>{props.cifras.dtot}</p></Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="margeninf">
        <Col xs={10}></Col>
        <Col xs={2} className="text-left">
          <p className="fontmaspeque">&nbsp;</p>
        </Col>
      </Row>
    </div>
  );
} //DatosCifrasSupNEE

function LlenaCedula(){
  //const { estad, fechac911 } = useSelector((state) => state.esc);
  const { estad } = useSelector((state) => state.esc);
  let cadena=[];
  let reg=0;
  let regcct=2;
  let regxanexo=3;
  let anexos=0;
  let anexolleno=0;
  let regsinanexo=0;
  let lianexo=0;
  let lsanexo=0;
  const Ciclo=CicloCenso(1);
  reg=estad.length;
  ActHojas(reg,regcct,regxanexo);
  if (reg>0){
    if (reg<=2){
      cadena.push(
      <div>
        <CabezaCedula/>
        <IdentEsc/>
        <Card border="dark" style={{ width: 'auto' }}>
          <Card.Header className="text-center font-weight-bold"><VersionCifras/>ESTADÍSTICA DE INICIO DE CURSOS {Ciclo}</Card.Header>
          <Card.Body>
            <TotalAlumnos escuela={estad}/>
            {estad.map((items,index) => {return <DatosCifrasSup cifras={items} regxanexo={regxanexo} indice={index}/>})}
          </Card.Body>
        </Card>
        <PieCedulaMedia/>
      </div>);
    }else{
      cadena.push(
        <div>
          <CabezaCedula/>
          <IdentEsc/>
          <Card border="dark" style={{ width: 'auto' }}>
            <Card.Header className="text-center font-weight-bold"><VersionCifras/>ESTADÍSTICA DE INICIO DE CURSOS {Ciclo}</Card.Header>
            <Card.Body>
              <TotalAlumnos escuela={estad}/>
              {estad.map((items,index) => {
                if ((index>=0) && (index<=1)) {
                return <DatosCifrasSup cifras={items} regxanexo={regxanexo} indice={index}/>
                }else{return[]}
                })}
            </Card.Body>
          </Card>
          <PieCedulaMedia/>
        </div>);  
      anexos=(reg-regcct)/regxanexo;
      anexolleno=Math.trunc(anexos);
      regsinanexo=reg-regcct-(anexolleno*regxanexo);
      lianexo=regcct; /* comienza a partir del registro 2 y omite los registros 0 y 1 */
      lsanexo=regcct+regxanexo-1; /* abarca hasta el 4° registro incluyendo el registro 2 */
      if (anexolleno>0) {
        //anexos llenos
        for (let ii=1; ii <= anexolleno; ii++) {
          cadena.push(
            <div>
              <CabezaCedula/>
              <Card border="dark" style={{ width: 'auto'}}>
                <Card.Header className="text-center font-weight-bold"><VersionCifras/>ESTADÍSTICA DE INICIO DE CURSOS {Ciclo}</Card.Header>
                <Card.Body>
                  <ClaveEsc cvect={estad[0].cvect}/>
                  {estad.map((items,index) => {if ((index>=lianexo) && (index<=lsanexo))
                    {return <DatosCifrasSup cifras={items} regxanexo={regxanexo} indice={index}/>}else{return []}})
                  }
                </Card.Body>
              </Card>
              <PieCedulaMedia/>
            </div>);
          lianexo=lianexo+regxanexo;
          lsanexo=lsanexo+regxanexo;
        }
      }else{
        lsanexo=regcct+regsinanexo-1; /* abarca hasta el registro N incluyendo el registro 2 */
      }
      if (regsinanexo>0) {
        //anexos llenos
        cadena.push(
          <div>
            <CabezaCedula/>
            <Card border="dark" style={{ width: 'auto'}}>
              <Card.Header className="text-center font-weight-bold"><VersionCifras/>ESTADÍSTICA DE INICIO DE CURSOS {Ciclo}</Card.Header>
              <Card.Body>
                <ClaveEsc cvect={estad[0].cvect}/>
                {estad.map((items,index) => {if ((index>=lianexo) && (index<=lsanexo)) {return <DatosCifrasSup cifras={items} regxanexo={regxanexo} indice={index}/>}else{return []}})}
              </Card.Body>
            </Card>
            <PieCedulaMedia/>
          </div>);
      }
    }
    /* Anexo de necesidades educativas especiales */
    /* {estad.map((items,index) => {return <DatosCifrasSupNEE cifras={items} regxanexo={regxanexo} indice={index}/>})}*/
      cadena.push(
        <div>
          <CabezaCedula/>
          <Card border="dark" style={{ width: 'auto'}}>
            <Card.Header className="text-center font-weight-bold"><VersionCifras/>ESTADÍSTICA DE INICIO DE CURSOS {Ciclo}</Card.Header>
            <Card.Body>
              <ClaveEsc cvect={estad[0].cvect}/>
              {estad.map((items,index) => {return <DatosCifrasSupNEE cifras={items} regxanexo={regxanexo} indice={index}/>})}
            </Card.Body>
          </Card>
          <PieCedulaMedia/>
        </div>);
  }
  return <Container padding="4rem">{cadena}</Container>;
} //LlenaCedula  

class CedSup extends React.Component {
  render(){
    return (
      <div id='supplantel'>
        <Container padding="4rem">
          <LlenaCedula/>
        </Container>
      </div>
    )
  }
}
export default CedSup;